bms = document.getElementById('bms')
tv = document.getElementById('tv')
kff = document.getElementById('kff')
sek = document.getElementById('sek')
feedback = document.getElementById('feedback')



function updateFields () {
    var bmsPercent = bms.value * (100/94)
    var tvPercent = tv.value * (100/12)
    var kffPercent = kff.value * (100/75)
    var sekPercent = sek.value * (100/20)

    result = (bmsPercent*0.4) + (tvPercent * 0.1) + (kffPercent * 0.4) + (sekPercent * 0.1)

    if (String(result) != 'Infinity' && String(result) != 'NaN') {
        result = Math.round(result);
        updateFeedback(result);
    }
}


function updateFeedback(prozentrang) {
    if (prozentrang == String(0)) {
        feedback.innerHTML = `
        
        Bitte überprüfe deine Eingabe.
        `
    } else {
        feedback.innerHTML = `
        <h1> Dein Ergebnis </h1>
        Dein Prozentrang ist ${prozentrang}%.
        `
    }
}